// extracted by mini-css-extract-plugin
export default {"cell":"styles-module__cell__src-labstep-web-grid-NewIndex-coldefs-bulk-select-_Uh2Oy"};